<app-login-layout class="app-dark-theme">
  <main class="register-carrier-final-step container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 col-md-7 offset-md-5 col-lg-5 offset-lg-7">
          <h2 class="text-center">Final Step</h2>
          <h4 class="text-center mt-5">
            Let's verify your information
          </h4>
          <h3 class="text-center mt-5">
            Your Account is Pending Approval.
            <br/>
            Please allow up to 48 hours to have your account activated
          </h3>
      </div>
    </div>
  </main>
</app-login-layout>
